'use strict';
import defaults from 'lodash/defaults';

export const TRACK_LOCATION_NAME = 'trackLocation';
export const TRACK_LOCATION_PREFIX = `@@${TRACK_LOCATION_NAME}`;

const START_TRACKING = `${TRACK_LOCATION_PREFIX}/START_TRACKING`;
const STOP_TRACKING = `${TRACK_LOCATION_PREFIX}/STOP_TRACKING`;
const RESET_TRACKING_CACHE = `${TRACK_LOCATION_PREFIX}/RESET_TRACKING_CACHE`;
const REGISTER_TRACKING = `${TRACK_LOCATION_PREFIX}/REGISTER_TRACKING`;
const DEREGISTER_TRACKING = `${TRACK_LOCATION_PREFIX}/DEREGISTER_TRACKING`;
const UPDATE_POSITION = `${TRACK_LOCATION_PREFIX}/UPDATE_POSITION`;

/**
 * @return {ReduxAction<Void>}
 */
export function startTracking() {
  return {
    type: START_TRACKING,
    payload: {},
  };
}
startTracking.TYPE = START_TRACKING;

/**
 * @return {ReduxAction<Void>}
 */
export function stopTracking() {
  return {
    type: STOP_TRACKING,
    payload: {},
  };
}
stopTracking.TYPE = STOP_TRACKING;

/**
 * Remove the last cached payload from the store.
 * @return {ReduxAction<Void>}
 */
export function resetTrackingCache() {
  return {
    type: RESET_TRACKING_CACHE,
    payload: {},
  };
}
resetTrackingCache.TYPE = RESET_TRACKING_CACHE;

/**
 * @typedef {Object} ChangeTrackingPayload
 * @property {String} key
 * @property {Boolean} [resumeOnLoad=true]
 * @property {Boolean} [once=false]
 */

const registerTrackingDefaults = {
  resumeOnLoad: true,
  once: false,
};

/**
 * TODO: add options: resumeOnLoad: true|false, once: true|false
 * @param {ChangeTrackingPayload} p
 * @return {ReduxAction<ChangeTrackingPayload>}
 */
export function registerTracking(p) {
  const payload = p || {};
  defaults(payload, registerTrackingDefaults);
  return {
    type: REGISTER_TRACKING,
    payload,
  };
}
registerTracking.TYPE = REGISTER_TRACKING;

/**
 * @param {ChangeTrackingPayload} payload
 * @return {ReduxAction<ChangeTrackingPayload>}
 */
export function deregisterTracking(payload) {
  return {
    type: DEREGISTER_TRACKING,
    payload: payload || {},
  };
}
deregisterTracking.TYPE = DEREGISTER_TRACKING;

/**
 * @typedef {Object} UpdatePositionPayload
 * @property {GpsStatus} gpsStatus
 * @property {Number} timestamp
 * @property {Position} [position]
 * @property {String} [location]
 * @property {Error} [err]
 */

/**
 * @param {UpdatePositionPayload} payload
 * @return {ReduxAction<UpdatePositionPayload>}
 */
export function updatePosition(payload) {
  return {
    type: UPDATE_POSITION,
    payload: payload || {},
  };
}
updatePosition.TYPE = UPDATE_POSITION;

/**
 * @typedef {Object} TrackLocationActions
 * @property {Function|ReduxActionCreator<Void>} startTracking
 * @property {Function|ReduxActionCreator<Void>} stopTracking
 * @property {Function|ReduxActionCreator<Void>} resetTrackingCache
 * @property {Function|ReduxActionCreator<ChangeTrackingPayload>} registerTracking
 * @property {Function|ReduxActionCreator<ChangeTrackingPayload>} deregisterTracking
 * @property {Function|ReduxActionCreator<UpdatePositionPayload>} updatePosition
 */



// WEBPACK FOOTER //
// ./src/js/settings/actions/trackLocationActions.js